/** @jsxImportSource @emotion/react */

import { Typography } from "../..";
import { Spinner } from "../../Spinner";
import { buttonCSS, sizeStyles, variantStyles } from "./TextButton.css";
import type { TextButtonProps } from "./TextButton.types";

export const TextButton = ({
  variant,
  as,
  className,
  onClick,
  icon,
  iconPosition = "left",
  leadingIcon: _leadingIcon,
  trailingIcon: _trailingIcon,
  size = "medium",
  sx,
  text,
  native,
  isLoading,
  ...restProps
}: TextButtonProps) => {
  const Element = as || "button";

  const leadingIcon = icon && iconPosition === "left" ? icon : _leadingIcon;
  const trailingIcon = icon && iconPosition === "right" ? icon : _trailingIcon;
  const isTextOnly = !leadingIcon && !trailingIcon;

  return (
    <Element
      className={className}
      css={[buttonCSS, sizeStyles[size], variantStyles[variant], sx]}
      data-imweb-loading={isLoading}
      onClick={onClick}
      {...restProps}
      {...native}
    >
      {(leadingIcon || isTextOnly) && isLoading ? <Spinner /> : leadingIcon}
      <Typography variant={`label-${size}-bold`} sx={{ color: "inherit" }}>
        {text}
      </Typography>
      {trailingIcon && isLoading ? <Spinner /> : trailingIcon}
    </Element>
  );
};
